
<template>
  <div>
    <h1>This is Test Page!!</h1>
    <button @click="post">Click Here!!</button>
    <div id="response">{{ response }}</div>
  </div>
</template>


<script>
export default {
  data: () => ({
    response: "初期"
  }),
  mounted: function() {
    this.$http
      .get("/users/own")
      .then(res => {
        this.response = res.data;
      })
      .catch(error => {
        alert("エラーが発生しました。" + error);
        // this.$router.push({
        //   path: "login",
        //   query: { backuri: this.$route.path }
        // });
      });
  },
  methods: {
    post() {
      this.$http
        .post(
          "/protected/csrf",
          {},
          {
            headers: {
              "X-CSRF-TOKEN": this.$cookies.get("csrf_access_token")
            }
          }
        )
        .then(res => {
          if (res.status == 200) {
            alert("postできたよ");
          } else {
            // eslint-disable-next-line no-console
            console.log(res);
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }
  }
};
</script>